<template>
    <div>
        <el-form inline>
            <el-form-item>
                <el-date-picker v-model="range" type="monthrange" format="MMM yyyy" value-format="yyyy-MM-dd"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="doExport" :disabled="loading"><i class="far fa-file-export"></i></el-button>
            </el-form-item>
        </el-form>
    </div>

</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    name: 'NewsHostingExportForm',
    data() {
        let defaultRange;
        let month = new Date().getMonth();
        if (month < 2) {
            defaultRange = [new Date(new Date().getFullYear() - 1, 0), new Date(new Date().getFullYear(), month)];
        } else {
            defaultRange = [new Date(new Date().getFullYear(), 0), new Date(new Date().getFullYear(), 11)];
        }
        return {
            loading: false,
            range: defaultRange.map(d => moment(d).format('YYYY-MM-DD')) // чтобы не возиться с таймзонами
        }
    },
    methods: {
        doExport() {
            if (this.loading) {
                return;
            }

            let request = {from: this.range[0], to: this.range[1]};
            axios({
                url: this.$store.state.apiUrl + '/ds_monitoring/newsHostingExport',
                method: 'POST',
                data: JSON.stringify(request),
                responseType: 'blob',
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
            }).then((resp) => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(resp.data);
                link.setAttribute('download', 'teq_news.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.loading = false;
            });
            this.loading = true;


        },
    }
}
</script>


<style lang="scss">

</style>